import { useRecoilValue } from "recoil";
import { engageEmbedState } from "../../atoms/engage";
import { engageState } from "../../atoms/platform";

import { MenuIcon } from "@heroicons/react/outline";

function EngageMenuButton({ setSidebarOpen }) {
  const isEmbed = useRecoilValue(engageEmbedState);
  const engageClient = useRecoilValue(engageState);

  return (
    <>
      {isEmbed ? (
        <>
          <div className="hidden md:block absolute top-0 left-1 z-10">
            <button
              type="button"
              className="pl-3 p-4 text-gray-800 focus:outline-none rounded-lg bg-coolGray-300"
              onClick={() => setSidebarOpen(true)}
            >
              <span className="sr-only">Open sidebar</span>
              <MenuIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="relative z-10 flex-shrink-0 flex h-12 bg-white shadow md:hidden">
            <button
              type="button"
              className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none"
              onClick={() => setSidebarOpen(true)}
            >
              <span className="sr-only">Open sidebar</span>
              <MenuIcon className="h-6 w-6" aria-hidden="true" />
            </button>
            <div className="flex-1 px-4 flex justify-between items-center">
              <p>{engageClient?.clientName}</p>
            </div>
          </div>
        </>
      ) : (
        <div className="relative z-10 flex-shrink-0 flex h-12 bg-white shadow lg:hidden">
          <button
            type="button"
            className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 lg:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <MenuIcon className="h-6 w-6" aria-hidden="true" />
          </button>
          <div className="flex-1 px-4 flex justify-between items-center">
            <p className="text-xl">{engageClient?.clientName}</p>
          </div>
        </div>
      )}
    </>
  );
}

export default EngageMenuButton;
